import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import {
  getGlobalSearchCandidateAfterJobCreatedApi,
  getMappedCandidatesAPi,
} from "../../../../../slices/aiSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { toast } from "sonner";
import NoDataFoundIcon from "../../../../../assets/Icons/NoDataFoundIcon";
import Tooltip from "../../../../../components/tool-tip/Tooltip";
import { useParams } from "react-router-dom";
import Popup from "../../../../../components/popup/Popup";
import GlobalSearchForm from "./GlobalSearchForm";
import LoadingIcon from "../../../../../assets/Icons/LoadingIcon";
import ExCheckBox from "../../../../../components/basic-components/ExCheckBox";
import PreviewIcon from "../../../../../assets/Icons/PreviewIcon";
import DownloadIcon from "../../../../../assets/Icons/DownloadIcon";
import moment from "moment";
import axios from "axios";
import * as constants from "../../../../../constant";
import useIndustries from "../../../../../utils/dropdown-options/useIndustries";
import useLocations from "../../../../../utils/dropdown-options/useLocations";
import ExcelJS from "exceljs";

const GlobalSearchJobLevelList = () => {
  const dipsatch = useAppDispatch();

  const { jobId } = useParams();
  const token = useAppSelector((state) => state?.login?.session?.token);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [usersData, setUsersData] = useState({
    users: [],
    metadata: null,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
  const [togglePopup, setTogglePopup] = useState(false);
  const [preview, setPreviewImages] = useState([]);

  const fetchData = async () => {
    try {
      const response = await dipsatch(
        getGlobalSearchCandidateAfterJobCreatedApi(jobId)
      ).then(unwrapResult);
      setUsersData({
        users:
          response?.data?.data?.users && response?.data?.data?.users?.length > 0
            ? response?.data?.data?.users
            : [],
        metadata: response?.data?.data?.metadata,
      });
      setIsLoading(false);
      setError(false);
    } catch (error) {
      setIsLoading(false);
      setError(true);
      toast.error("Something went wrong");
    }
  };

  const addMorePopupHandler = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const togglePopupHandler = (attachment) => {
    console.log(attachment, "attachmentattachment");
    setPreviewImages(attachment);
    setTogglePopup(!togglePopup);
  };

  var newRecords = usersData?.users?.filter(
    (user) => user.isFromAddMore == true
  );
  var oldRecords = usersData?.users?.filter(
    (user) => user.isFromAddMore == false
  );

  const downloadMultipleFiles = async () => {
    let exportList = usersData?.users?.filter((can) =>
      selectedCandidateIds.includes(can.id)
    );
    const workbook = new ExcelJS.Workbook();
    // Add a worksheet
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.columns = [
      { header: "Sr.No", key: "Sr.No", width: 20 },
      { header: "Candidate Name", key: "Candidate Name", width: 20 },
      { header: "Current Designation", key: "Current Designation", width: 20 },
      { header: "Current Company", key: "Current Company", width: 20 },
      { header: "LinkedIn ID", key: "LinkedIn ID", width: 20 },
      {
        header: "Professional Summary",
        key: "Professional Summary",
        width: 20,
      },
      { header: "Industry", key: "Industry", width: 20 },
      { header: "Relevant Experience", key: "Relevant Experience", width: 20 },
      { header: "Location", key: "Location", width: 20 },
      { header: "Skills", key: "Skills", width: 20 },
      { header: "Education", key: "Education", width: 20 },
      { header: "Date/Time", key: "Date/Time", width: 20 },
    ];
    // Apply bold to the header row
    worksheet.getRow(1).font = { bold: true, size: 12 };

    exportList.forEach((item, i) => {
      const customizedData = [
        i + 1,
        `${item.firstName}  ${item.lastName}`, // Example: Capitalize name
        item.title,
        item.currentCompany,
        item.linkedinID,
        item.professionalSummary,
        item.industry,
        item.experience,
        item.location,
        item.skills,
        item.education,
        `${moment(item.createdAt).format("DD/MM/YYYY")}/
                      ${moment(item.createdAt).format("LT")}`,
      ];
      const row = worksheet.addRow(customizedData);

      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
        cell.alignment = { horizontal: "left" };
      });
    });

    // Save the file as a blob and download it
    workbook.xlsx.writeBuffer().then((buffer) => {
      const data = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(data);
      link.download = `Exported_candidate_mapping_list.xlsx`;
      link.click();
    });
  };

  const singleDownloadFiles = (url, name) => {
    const link = document.createElement("a");
    link.href = `${constants.baseUrl}/${url}?t=${token}`;
    link.download = `${name}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCheckedClick = () => {
    if (selectedCandidateIds.length > 0) {
      setSelectedCandidateIds([]);
    } else {
      let selectedIds = usersData?.users.map((can) => can.id);
      setSelectedCandidateIds([...selectedIds]);
    }
  };

  const handleSingleCheckBoxClick = (id) => {
    var candidateIds = selectedCandidateIds;
    if (selectedCandidateIds.includes(id)) {
      candidateIds = candidateIds.filter((Id) => id != Id);
      setSelectedCandidateIds([...candidateIds]);
    } else {
      candidateIds.push(id);
      setSelectedCandidateIds([...candidateIds]);
    }
  };

  const { defaultIndustries } = useIndustries();
  const { defaultLocations } = useLocations();
  const [rerunDisable, setRerunDisable] = useState(false);
  const jobDetails = useAppSelector((state) => state.jobs.jobById.jobDetail);

  const rerunGlobalSearch = async () => {
    setRerunDisable(true);
    let industries = defaultIndustries(jobDetails.industries.map(Number)).map(
      (obj) => obj.Name
    );
    let location = defaultLocations(jobDetails.location.map(Number)).map(
      (obj) => obj.Name
    );
    const toastId = toast.loading("Fetching data...");
    try {
      const response = await dipsatch(
        getMappedCandidatesAPi({
          industry: industries,
          title: jobDetails.title,
          subIndustry: null,
          iterations: 2,
          Master_Excel_Path: null,
          addPrompt: "",
          location: location,
          clientCompany: jobDetails.company,
          company_No: 30,
          companyId: jobDetails.companyId,
          jobId: jobDetails.id,
          jobDetails: jobDetails.description,
        })
      ).then(unwrapResult);
      toast.dismiss(toastId);
      if (response.count === 0) toast.error("Candidates not found");
      else {
        setRerunDisable(false);
        toast.success("Candidates fetched successfully");
      }
    } catch (error) {
      setRerunDisable(false);
      toast.dismiss(toastId);
      toast.error("Something went wrong!");
    }
  };

  if (error) {
    return (
      <div className="w-full">
        <div className="mx-auto w-fit py-5">
          <div className="flex items-center justify-center">
            <NoDataFoundIcon />
          </div>
          <div>
            <h1 className="text-3xl text-expurple-800/50 font-semibold text-center">
              Something Went Wrong
            </h1>
            <p className="text-base text-exgray-200 font-medium text-center max-w-sm mx-auto">
              Could not find any data from the global search. Please try again.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="py-20 flex items-center justify-center">
        <LoadingIcon />
      </div>
    );
  }

  return (
    <div className="">
      <div className="flex items-center justify-between my-4">
        <div className="w-[40%] flex items-center justify-start gap-2">
          <button
            onClick={() => downloadMultipleFiles()}
            disabled={selectedCandidateIds.length === 0}
            className={`text-exwhite-100 ${
              selectedCandidateIds.length === 0
                ? "bg-exgray-300"
                : "bg-secondary-400"
            } px-5 py-1 rounded-xl mr-5 text-nowrap`}
          >
            Download
            {selectedCandidateIds.length > 0
              ? `  (${selectedCandidateIds.length})`
              : ""}
          </button>
          <div className="flex">
            <div className="flex items-center">
              <div className="h-6 w-6 rounded-sm bg-exgray-100/90 border border-exgray-300"></div>
              <h1 className="text-exgray-600 ml-2 text-nowrap">
                New Record ({newRecords.length})
              </h1>
            </div>
            <div className="flex items-center ml-5">
              <div className="h-6 w-6 rounded-sm bg-exwhite-100 border border-exgray-300"></div>
              <h1 className="text-exgray-600 ml-2 text-nowrap">
                Old Record ({oldRecords.length})
              </h1>
            </div>
          </div>
        </div>
        <div className="">
          <button
            disabled={rerunDisable}
            className={`text-base ${
              rerunDisable
                ? "bg-exgray-300"
                : "bg-secondary-400 hover:bg-secondary-600"
            } text-exwhite-100 font-semibold text-center px-4 py-1 rounded-full active:scale-95`}
            onClick={() => rerunGlobalSearch()}
          >
            Rerun
          </button>

          <button
            className={`ml-3 text-base border-2 border-secondary-400 hover:bg-secondary-600 bg-secondary-400 text-exwhite-100 font-semibold text-center px-4 py-1 rounded-full active:scale-95`}
            onClick={addMorePopupHandler}
          >
            Add More Candidate
          </button>
        </div>
      </div>
      <div className="max-h-popupScreenheight overflow-x-auto rounded-t-md no-scrollbar">
        <table className="min-w-full bg-white">
          <thead className="sticky top-0 bg-gray-100 z-10 bg-secondary-500">
            <tr className="text-left">
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100">
                <ExCheckBox
                  className="text-exwhite-100"
                  checked={
                    selectedCandidateIds.length === usersData?.users.length
                  }
                  onChange={() => handleCheckedClick()}
                  name={undefined}
                  title={undefined}
                />
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100">
                S.No.
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100">
                Preview
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                Candidate Name
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                Current Designation
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                Current Company
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                LinkedIn ID
              </th>
              <th className="border border-gray-300 px-4 py-2 text-nowrap text-sm font-semibold text-exwhite-100 text-center">
                Professional Summary
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                Industry
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm text-nowrap font-semibold text-exwhite-100 text-center">
                Relevant Experience
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                Location
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                Skills
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                Education
              </th>
              <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exwhite-100 text-center">
                Date/Time
              </th>
              {/* <th className="border border-gray-300 px-4 py-2 text-sm font-semibold text-exgray-200">
      ProfessionalSummary
    </th> */}
            </tr>
          </thead>
          {/* <tbody>
            {usersData?.users?.map((candidate, i) => (
              <tr key={i + "can"} className="hover:bg-gray-50">
                <td className="px-4 py-2 text-sm text-gray-600">{i + 1}</td>
                <td className="px-4 py-2 text-sm text-gray-600 text-nowrap font-semibold">
                  {candidate?.firstName} {candidate?.lastName}
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate.title}>
                    <div className="line-clamp-2">{candidate.title}</div>
                  </Tooltip>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  {candidate.location}
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  {candidate.totalExperience}
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate?.currentCompany}>
                    <div className="line-clamp-2">
                      {candidate?.currentCompany}
                    </div>
                  </Tooltip>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate?.previousCompany}>
                    <div className="line-clamp-2">
                      {candidate?.previousCompany}
                    </div>
                  </Tooltip>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate.skills}>
                    <div className="line-clamp-2">{candidate.skills}</div>
                  </Tooltip>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate.education}>
                    <div className="line-clamp-2">{candidate.education}</div>
                  </Tooltip>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate.experience}>
                    <div className="line-clamp-2">{candidate.experience}</div>
                  </Tooltip>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate.industry}>
                    <div className="line-clamp-2">{candidate.industry}</div>
                  </Tooltip>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600 max-w-40">
                  <a
                    href={candidate?.linkedinID}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 underline break-words"
                  >
                    {candidate?.linkedinID}
                  </a>
                </td>
                <td className="px-4 py-2 text-sm text-gray-600">
                  <Tooltip text={candidate?.professionalSummary}>
                    <div className="line-clamp-2">
                      {candidate?.professionalSummary}
                    </div>
                  </Tooltip>
                </td>
              </tr>
            ))}
          </tbody> */}
          <tbody className="divide-y divide-gray-300">
            {usersData?.users?.map((candidate, i) => (
              <tr
                key={i + "can"}
                className={`${
                  candidate.isFromAddMore ? "bg-exgray-100/90" : ""
                }`}
              >
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                  <ExCheckBox
                    className="text-exwhite-100"
                    checked={selectedCandidateIds.includes(candidate.id)}
                    onChange={() => handleSingleCheckBoxClick(candidate.id)}
                    name={undefined}
                    title={undefined}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                  {i + 1}
                </td>
                <td className="px-4 py-2 text-sm ">
                  <div className="flex items-center justify-center">
                    <div
                      className="items-center"
                      onClick={() =>
                        togglePopupHandler(candidate.preview.Preview)
                      }
                    >
                      <PreviewIcon />
                    </div>
                    <div
                      onClick={() =>
                        singleDownloadFiles(
                          candidate.actual.Actual,
                          `${candidate.firstName}_${candidate.lastName}`
                        )
                      }
                      className="items-center ml-3"
                    >
                      <DownloadIcon />
                    </div>
                  </div>
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                  {candidate["firstName"]} {candidate["lastName"]}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                  {candidate.title}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                  {candidate.currentCompany}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 max-w-lg">
                  <a
                    className="text-secondary-500"
                    target="_blank"
                    href={candidate.linkedinID}
                  >
                    {candidate.linkedinID}
                  </a>
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                  {candidate.professionalSummary}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 text-nowrap truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                  {candidate.industry}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                  {candidate.experience}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                  {candidate.location}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                  {candidate.skills}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 truncate max-w-sm hover:max-w-full hover:overflow-visible hover:whitespace-normal hover:font-medium group">
                  {candidate.education}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600 text-nowrap">
                  {moment(candidate.createdAt).format("DD/MM/YYYY")}{" "}
                  {moment(candidate.createdAt).format("LT")}
                </td>
                {/* <td className="border border-gray-300 px-4 py-2 text-sm text-gray-600">
                    <Tooltip text={candidate["Professional Summary"]}>
                      <div className="line-clamp-3">
                        {candidate["Professional Summary"]}
                      </div>
                    </Tooltip>
                  </td> */}
              </tr>
            ))}
          </tbody>
        </table>

        {usersData?.users && usersData?.users?.length === 0 && (
          <div className="w-full">
            <div className="mx-auto w-fit py-5">
              <div className="flex items-center justify-center">
                <NoDataFoundIcon />
              </div>
              <div>
                <h1 className="text-3xl text-expurple-800/50 font-semibold text-center">
                  No Data Found
                </h1>
                <p className="text-base text-exgray-200 font-medium text-center max-w-sm mx-auto">
                  Could not find any data from the global search. Please try
                  again.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      <Popup onClose={() => setIsPopupOpen(false)} visible={isPopupOpen}>
        <GlobalSearchForm onClose={() => setIsPopupOpen(false)} jobId={jobId} />
      </Popup>

      <Popup
        onClose={togglePopupHandler}
        visible={togglePopup}
        isCloseButton={false}
      >
        <div className="px-10 py-6 w-[60%] mx-auto bg-white shadow-md rounded-lg max-h-[80vh] overflow-y-auto">
          {preview?.map((att) => {
            return (
              <div>
                <img
                  src={`${constants.baseUrl}/${att}?t=${token}`}
                  alt="preview"
                  className="h-full w-full"
                />
              </div>
            );
          })}
        </div>
      </Popup>
    </div>
  );
};

export default GlobalSearchJobLevelList;
